import $store from '../../../store'

// trtc-sdk-v5 按需动态加载，避免打入主包；加载后缓存在模块内供 enterRoom/startLocal 等使用
let _TRTC = null
let _trtcV5errorCode = null
async function ensureTRTC () {
  if (_TRTC) return _TRTC
  const trtcMod = await import(/* webpackChunkName: "trtc-sdk-v5" */ 'trtc-sdk-v5')
  _TRTC = trtcMod.default || trtcMod
  if (!_TRTC || typeof _TRTC.setLogLevel !== 'function') {
    throw new Error('TRTC SDK 加载失败，请刷新重试')
  }
  const errMod = await import(/* webpackChunkName: "trtc-proctor" */ './trtcV5errorCode')
  _trtcV5errorCode = errMod.default || errMod
  _TRTC.setLogLevel(5)
  return _TRTC
}
export const getTRTC = ensureTRTC

// 创建TRTC对象streamObj:{transactionId, userId}
export const create = async (streamObj, callBack, errorCallBack) => {
  try {
    const TRTC = await ensureTRTC()
    const trtc = TRTC.create()
    callBack(trtc)
  } catch (error) {
    console.log(error)
    errorCallBack(_trtcV5errorCode(_TRTC, streamObj, undefined, error))
  }
}

// 浏览器环境检测
export const isReport = async (streamObj, callBack, errorCallBack) => {
  const TRTC = await ensureTRTC()
  TRTC.checkSystemRequirements().then(checkResult => {
    if (checkResult.result && checkResult.detail.isH264DecodeSupported && checkResult.detail.isH264EncodeSupported) {
      // 支持进房  支持拉流  支持推流
      callBack(true)
    } else {
      errorCallBack(false)
    }
  })
}

// 加房
export const enterRoom = (streamObj, trtc, strRoomId, sdkAppId, userId, userSig, callBack, errorCallBack, startLocal = '') => {
  trtc.enterRoom({ strRoomId, sdkAppId, userId, userSig }).then(res => {
    callBack(res)
  }).catch(err => {
    errorCallBack(_trtcV5errorCode(_TRTC, streamObj, startLocal, err))
  })
}
/* eslint-disable */
// 本地视频流采集及发布 startLocalAudio/startLocalVideo/startScreenShare
/*
  视频：
  view:预览视频的div
  option:{
    mute:是否粘贴摄像头采集，
    cameraId:指定使用哪个摄像头，用于切换摄像头
    useFrontCamera:是否使用前置摄像头
    videoTrack:videoTrack。
    mirror:是否开启本地预览镜像，默认为 true。
    fillMode:'contain' | 'cover' | 'fill'	视频填充模式。默认为 cover。
    profile:视频大流编码参数。
    small:视频小流编码参数，参考：开启大小流
    qosPreference:设置弱网时，视频编码策略。（默认）流畅度优先（QOS_PREFERENCE_SMOOTH）或 清晰度优先（QOS_PREFERENCE_CLEAR）
  }
  音频：
  option:{
    microphoneId：指定使用哪个麦克风
    audioTrack：自定义采集的 audioTrack。
    captureVolume：设置采集音量，默认值 100，设置小于 100 可以降低采集音量，设置大于 100 可以放大采集音量，注意有爆音风险。自 v5.2.1+ 支持。
    earMonitorVolume：设置耳返音量，取值[0, 100]，本地麦克风默认静音播放。
    profile：音频编码配置, 默认TRTC.TYPE.AUDIO_PROFILE_STANDARD
  }
  共享屏幕：
  view:预览视频的div
  option:{
    systemAudio:是否采集系统声音，默认为 false。
    fillMode:视频填充模式。默认为 contain。
    profile:屏幕分享编码配置。
    qosPreference:设置弱网时，视频编码策略。流畅度优先（QOS_PREFERENCE_SMOOTH）或 （默认）清晰度优先（QOS_PREFERENCE_CLEAR）
    videoTrack:自定义采集的 videoTrack。
  }
*/
export const startLocal = async (streamObj, trtc, startLocal, div, option, publish, mute, callBack, errorCallBack) => {
  const config = {
    view: div || null,
    publish, // 不发布摄像头=> false为不发布
    ...option,
    mute     // 是否静音
  }
  trtc[startLocal]({ ...config }).then(res => {
    callBack(res)
  }).catch(err => {
    errorCallBack(_trtcV5errorCode(_TRTC, streamObj, startLocal, err))
  })
  // try {
  //   await trtc[startLocal]({ ...config })
  //   callBack(1)
  // } catch (error) {
  //   errorCallBack(trtcV5errorCode(streamObj, startLocal, error))
  // }
}

// 更新视频配置
export const updateLocal = (streamObj, trtc, updateLocal, obj, callBack, errorCallBack) => {
  console.log('this.cameraClient', streamObj, trtc, updateLocal, obj, trtc && trtc[updateLocal])
  trtc && trtc[updateLocal] && trtc[updateLocal]({ ...obj }).then(res => {
    console.log('this.cameraClient', res)
    callBack(res)
  }).catch(err => {
    console.log('this.cameraClient', err)
    // if (err.code === TRTC.ERROR_CODE.DEVICE_ERROR) {
    // }
    errorCallBack(_trtcV5errorCode(_TRTC, streamObj, updateLocal, err))
  })
}

// 静音某个远端客户，并且不再拉取该用户的音频数据（仅对当前用户有效，房间内其他用户依然可以听到被静音用户的声音）,true为静音，false不静音
export const muteRemoteAudio = (streamObj, trtc, userId, mute, callBack, errorCallBack, startLocal = '') => {
  trtc.muteRemoteAudio(userId, mute).then(res => {
    callBack(res)
  }).catch(err => {
    errorCallBack(_trtcV5errorCode(_TRTC, streamObj, startLocal, err))
  })
}

// 用于控制远端音频的播放音量。不支持 iOS Safari
export const setRemoteAudioVolume = (streamObj, trtc, userId, volume, callBack, errorCallBack, startLocal = '') => {
  trtc.muteRemoteAudio(userId, volume).then(res => {
    callBack(res)
  }).catch(err => {
    errorCallBack(_trtcV5errorCode(_TRTC, streamObj, startLocal, err))
  })
}

// 退出房间
export const exitRoom = (streamObj, trtc, callBack, errorCallBack, startLocal = '') => {
  trtc && trtc.exitRoom() && trtc.exitRoom().then(res => {
    callBack(res)
  }).catch(err => {
    errorCallBack(_trtcV5errorCode(_TRTC, streamObj, startLocal, err))
  })
}

// 停止本地音视频流采集 --- stopLocalAudio,stopLocalVideo,stopScreenShare
export const stopLocalStream = async (streamObj, trtc, stopLocalVideo, callBack, errorCallBack) => {
  const _TRTC = await ensureTRTC()
  trtc && trtc[stopLocalVideo] && trtc[stopLocalVideo]().then(res => {
    callBack(res)
  }).catch(err => {
    errorCallBack(_trtcV5errorCode(_TRTC, streamObj, stopLocalVideo, err))
  })
}

// 获取摄像头
export const getCameraList = async (streamObj, callBack, errorCallBack) => {
  const _TRTC = await ensureTRTC()
  _TRTC.getCameraList().then(res => {
    callBack(res)
  }).catch(err => {
    errorCallBack(_trtcV5errorCode(_TRTC, streamObj, 'startLocalVideo', err))
  })
}
// 获取麦克风
export const getMicrophoneList = async (streamObj, callBack, errorCallBack) => {
  const _TRTC = await ensureTRTC()
  _TRTC.getMicrophoneList().then(res => {
    callBack(res)
  }).catch(err => {
    errorCallBack(_trtcV5errorCode(_TRTC, streamObj, 'startLocalAudio', err))
  })
}

// 监听事件
/**
 *
 * @param {Array} eventList
 * @param {Function} callBack
 * @param {Function} errorCallBack
 * @param {String} view
 */
export const onTRTC = (streamObj, trtc, type, eventList, callBack, errorCallBack, view) => {
  // 错误事件，非 API 调用错误，SDK 在运行过程中出现了不可恢复的错误时抛出。
  if (eventList.indexOf('ERROR') > -1) {
    trtc.on(_TRTC.EVENT.ERROR, err => {
      errorCallBack(_trtcV5errorCode(_TRTC, streamObj, type, err))
      if (err.handler) {
        err.handler()
      }
    })
  }
  // 自动播放失败
  if (eventList.indexOf('AUTOPLAY_FAILED') > -1) {
    trtc.on(_TRTC.EVENT.AUTOPLAY_FAILED, event => {
      // 引导用户点击页面，当用户点击页面时，SDK 会自动恢复播放。
      // 自 v5.1.3+ 新增 userId 参数，表示哪个用户出现自动播放失败。
      console.log(event.userId)
    })
  }
  // 被踢出房间
  /**
   * kick: 相同 userId 的用户同时进入同一个房间（以下简称为同名进房），先进入房间的用户会被后进入的用户踢出房间。
   *       同名进房是不允许的行为，可能会导致双方音视频通话异常，业务侧应避免出现这种情况。
   *       TRTC 后台不保证观众角色同名进房互踢。即观众角色的用户，使用同 userId 进同一个房间，可能不会收到该事件。
   * banned: 系统管理员通过服务端 API 将该用户踢出房间。
   * room-disband: 系统管理员通过服务端 API 解散房间。
   */
  if (eventList.indexOf('KICKED_OUT') > -1) {
    trtc.on(_TRTC.EVENT.KICKED_OUT, event => {
      console.log(event.reason)
      if (event.reason !== 'kick') errorCallBack(event)
    })
  }
  // 远端用户进房事件。（live 模式下，只有主播才有进退房通知，观众没有进退房通知，观众可以收到主播的进退房通知。）
  if (eventList.indexOf('REMOTE_USER_ENTER') > -1) {
    trtc.on(_TRTC.EVENT.REMOTE_USER_ENTER, event => {
      // const userId = event.userId
    })
  }
  // 远端用户发布了音频。当远端用户打开麦克风后，您会收到该通知
  // 在进房前监听
  if (eventList.indexOf('REMOTE_AUDIO_AVAILABLE') > -1) {
    trtc.on(_TRTC.EVENT.REMOTE_AUDIO_AVAILABLE, event => {
      // const userId = event.userId
    })
  }
  // 远端停止发布了音频。当远端用户关闭麦克风后，您会收到该通知。
  // 在进房前监听
  if (eventList.indexOf('REMOTE_AUDIO_UNAVAILABLE') > -1) {
    trtc.on(_TRTC.EVENT.REMOTE_AUDIO_UNAVAILABLE, event => {
      // const userId = event.userId
    })
  }
  // 远端用户发布了视频，当远端用户开启摄像头后，您会收到该通知。
  // 在进房前监听
  if (eventList.indexOf('REMOTE_VIDEO_AVAILABLE') > -1) {
    trtc.on(_TRTC.EVENT.REMOTE_VIDEO_AVAILABLE, event => {
      console.log(333333333)
      const userId = event.userId
      const streamType = event.streamType
      trtc.startRemoteVideo({ userId, streamType, view })
      callBack({ code: 'my003' })
    })
  }
  // 远端用户停止发布视频，当远端用户关闭摄像头后，您会收到该通知。
  // 在进房前监听
  if (eventList.indexOf('REMOTE_VIDEO_UNAVAILABLE') > -1) {
    trtc.on(_TRTC.EVENT.REMOTE_VIDEO_UNAVAILABLE, event => {
      // const userId = event.userId
      // const streamType = event.streamType
      // 此时 SDK 会自动停止播放，无需调用 stopRemoteVideo
      callBack({ code: 'my001', desc: '远端视频流暂停了', state: 'PAUSE' })
    })
  }
  // 网络质量统计数据事件，进房后开始统计，每两秒触发一次，该数据反映的是您本地的上、下行的网络质量。
  if (eventList.indexOf('NETWORK_QUALITY') > -1) {
    trtc.on(_TRTC.EVENT.NETWORK_QUALITY, event => {
      console.log(`network-quality, uplinkNetworkQuality:${event.uplinkNetworkQuality}, downlinkNetworkQuality: ${event.downlinkNetworkQuality}`)
      console.log(`uplink rtt:${event.uplinkRTT} loss:${event.uplinkLoss}`)
      console.log(`downlink rtt:${event.downlinkRTT} loss:${event.downlinkLoss}`)
    })
  }
  // SDK 和腾讯云的连接状态变更事件，您可以利用该事件从总体上监听 SDK 与腾讯云的连接状态。
  /**
   * 'DISCONNECTED'：连接断开
   * 'CONNECTING'：正在连接中
   * 'CONNECTED'：已连接
   * 不同状态变更的含义：
   * DISCONNECTED -> CONNECTING: 正在尝试建立连接，调用进房接口或者 SDK 自动重连时触发。
   * CONNECTING -> DISCONNECTED: 连接建立失败，当正在连接时调用退房接口中断连接或者经过 SDK 重试后任然连接失败时触发。
   * CONNECTING -> CONNECTED: 连接建立成功，连接成功时触发。
   * CONNECTED -> DISCONNECTED: 连接中断，调用退房接口或者当网络异常导致连接断开时触发。
   */
  if (eventList.indexOf('CONNECTION_STATE_CHANGED') > -1) {
    trtc.on(_TRTC.CONNECTION_STATE_CHANGED, event => {
      // const prevState = event.prevState
      // const curState = event.state
    })
  }
  // 音频播放状态变更事件
  /**
   * event.userId 当 userId 为空串时，代表本地用户，非空串代表远端用户。
   * event.state 取值如下：
   * 'PLAYING'：开始播放
   * event.reason 为 'playing' 或者 'unmute'。
   * 'PAUSED'：暂停播放
   * event.reason 为 'pause' 时，由 <audio> element 的 pause 事件触发，如下几种情况会触发：
   * 调用 HTMLMediaElement.pause 接口。
   * event.reason 为 'mute' 时。详见事件 MediaStreamTrack.mute_event
   * 若 userId 为自己时 触发该事件，表明音频采集暂停，通常是设备异常引起，如设备被其他应用抢占，此时需引导用户重新采集。
   * 若 userId 为他人时 触发该事件，表明收到的音频数据不足以播放。通常是网络抖动引起，接入侧无需做任何处理。当收到的数据足以播放时，会自动恢复。
   * 'STOPPED'：停止播放
   * event.reason 为 'ended'。
   * event.reason 状态变化的原因，取值如下：
   *
   * 'playing'：开始播放，详见事件 HTMLMediaElement.playing_event
   * 'mute'：音频轨道暂时未能提供数据，详见事件 MediaStreamTrack.mute_event
   * 'unmute'：音频轨道恢复提供数据，详见事件 MediaStreamTrack.unmute_event
   * 'ended'：音频轨道已被关闭
   * 'pause'：播放暂停
   */
  if (eventList.indexOf('AUDIO_PLAY_STATE_CHANGED') > -1) {
    trtc.on(_TRTC.EVENT.AUDIO_PLAY_STATE_CHANGED, event => {
      if (event.state === 'PLAYING') callBack('audio')
      // if (event.state === 'STOPPED') errorCallBack({type: 'audio', code: 'my002'})
    })
  }
  // 视频播放状态变更事件
  if (eventList.indexOf('VIDEO_PLAY_STATE_CHANGED') > -1) {
    trtc.on(_TRTC.EVENT.VIDEO_PLAY_STATE_CHANGED, event => {
      if (event.state === 'PLAYING') callBack('video')
      // if (event.state === 'STOPPED') errorCallBack({type: 'video', code: 'my002'})
    })
  }
  // 本地屏幕分享停止事件通知，仅对本地屏幕分享流有效。
  if (eventList.indexOf('SCREEN_SHARE_STOPPED') > -1) {
    trtc.on(_TRTC.EVENT.SCREEN_SHARE_STOPPED, () => {
      console.log('screen sharing was stopped')
      callBack({ code: 'my001' })
    })
  }
  // 摄像头、麦克风等设备变化的通知事件。
  /**
   * event.device 是一个 MediaDeviceInfo 对象，属性：
   * deviceId：设备 Id
   * label：设备描述信息
   * groupId：设备 groupId
   * event.type 值：'camera'|'microphone'|'speaker'
   * event.action 值：
   * 'add' 设备已添加。
   * 'remove' 设备已被移除。
   * 'active' 设备已启动，例如：startLocalVideo 成功后，会触发该事件。
   */
  if (eventList.indexOf('DEVICE_CHANGED') > -1) {
    trtc.on(_TRTC.EVENT.DEVICE_CHANGED, (event) => {
      console.log(`${event.type}(${event.device.label}) ${event.action}`)
    })
  }
  // 推流状态变更事件。
  /**
   * event.mediaType 媒体类型，值：'audio'|'video'|'screen'。
   * event.state 当前的推流状态，值：
   * 'starting' 正在尝试推流
   * 'started' 推流成功
   * 'stopped' 推流停止，原因见 event.reason 字段
   * event.prevState 上一次事件触发时的推流状态，值和 event.state 相同。
   * event.reason 推流状态变为 'stopped' 的原因，值：
   * 'timeout' 推流超时，一般是由于网络抖动、防火墙拦截导致。SDK 会不断进行重试，业务侧可以在此时引导用户检查网络、更换网络。
   * 'error' 推流出错，此时可从 event.error 中获取到具体错误信息，一般是由于浏览器不支持 H264 编码导致。
   * 'api-call' 业务侧 api 调用导致推流停止，例如在 startLocalVideo 推流成功前，调用了 stopLocalVideo 停止了推流，属于正常行为，业务侧无需关注。
   * event.error event.reason 为 'error' 时的错误信息。
   */
  if (eventList.indexOf('PUBLISH_STATE_CHANGED') > -1) {
    trtc.on(_TRTC.EVENT.PUBLISH_STATE_CHANGED, (event) => {
      console.log('PUBLISH_STATE_CHANGED', event)
      // 推流停止增加回调 只有超时和报错需要重启
      if (event.state === 'stopped' && (event.reason === 'timeout' || event.reason === 'error')) {
        _trtcV5errorCode(_TRTC, streamObj, type, { ...event, upload: true })
        // console.log('PUBLISH_STATE_CHANGED stopped', event)
        if (type === 'startLocalVideo' && event.mediaType === 'video') {
          trtc.updateLocalVideo({ publish: false })
          $store.commit('set_cameraPublishState', false)
        } else if (type === 'startLocalAudio' && event.mediaType === 'audio') {
          trtc.updateLocalAudio({ publish: false })
          $store.commit('set_micPhonePublishState', false)
        } else if (event.mediaType === 'screen') {
          trtc.updateScreenShare({ publish: false })
          $store.commit('set_screenPublishState', false)
        }
      } else if (event.state === 'started') {
        // 推流成功
        // console.log('PUBLISH_STATE_CHANGED started', event)
        if (type === 'startLocalAudio' && event.mediaType === 'video') {
          $store.commit('set_cameraPublishState', true)
        } else if (type === 'startLocalAudio' && event.mediaType === 'audio') {
          $store.commit('set_micPhonePublishState', true)
        } else if (event.mediaType === 'screen') {
          $store.commit('set_screenPublishState', true)
        }
      }
    })
  }
  // 通话相关数据指标。
  /**
   * 监听该事件后，SDK 会以 2s 一次的频率定时抛出该事件。
   * 您可以从该事件中可以获取通话的网络质量（rtt、丢包率）、上行和下行的音视频统计信息（音量大小、宽高、帧率、码率）等信息。详细参数说明请参考：TRTCStatistics
   */
  if (eventList.indexOf('STATISTICS') > -1) {
    trtc.on(_TRTC.EVENT.STATISTICS, statistics => {
      console.warn(statistics.rtt, statistics.upLoss, statistics.downLoss)
    })
  }
  // 收到新的 MediaStreamTrack 对象
  if (eventList.indexOf('TRACK') > -1) {
    trtc.on(_TRTC.EVENT.TRACK, event => {
      // const isLocal = event.userId === '' // userId === '' means event.track is a local track, otherwise it's a remote track
      // const isSubStream = event.streamType === TRTC.TYPE.STREAM_TYPE_SUB // Usually the sub stream is a screen-sharing video stream.
      // const mediaStreamTrack = event.track
      // const kind = event.track.kind // audio or video
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/bloom-proctor/public/createTrtcV5.js